import { useNavigate } from "react-router-dom";
import CoachLayout from "@/components/CoachLayout";
import {
  Euro, Gift, Ticket, Share2, Dumbbell, BookOpen, Cog, Sliders,
  LineChart, ShieldCheck, ChevronRight, LayoutGrid, Activity,
} from "lucide-react";

const GROUPS = [
  {
    title: "Offres, tarifs & acquisition",
    hint: "Ta boutique, l'accès offert et les leviers d'acquisition.",
    items: [
      { to: "/coach/tarifs", label: "Tarifs", Icon: Euro, desc: "Offres, prix, promos de la boutique (source unique).", testid: "adminhub-pricing" },
      { to: "/coach/offre-bienvenue", label: "Offre de bienvenue", Icon: Gift, desc: "Accès gratuit des nouveaux : mode normal ou campagne.", testid: "adminhub-welcome" },
      { to: "/coach/promos", label: "Codes promo", Icon: Ticket, desc: "Réductions ponctuelles et codes de campagne.", testid: "adminhub-promos" },
      { to: "/coach/parrainage", label: "Parrainage", Icon: Share2, desc: "Programme de recommandation entre coureurs.", testid: "adminhub-referral" },
    ],
  },
  {
    title: "Contenu & méthode",
    hint: "Ce sur quoi MAI s'appuie pour construire les plans.",
    items: [
      { to: "/coach/methode", label: "Ma méthode", Icon: BookOpen, desc: "Principes et règles de coaching de la marque.", testid: "adminhub-method" },
    ],
  },
  {
    title: "Moteur IA",
    hint: "Réglages du moteur de génération et suivi des coûts.",
    items: [
      { to: "/coach/moteur", label: "Moteur", Icon: Cog, desc: "Règles de programmation et garde-fous.", testid: "adminhub-engine" },
      { to: "/coach/moteur-mai", label: "Moteur MAI", Icon: Sliders, desc: "Comportement et réglages de l'assistant MAI.", testid: "adminhub-mai-engine" },
      { to: "/coach/cout-ia", label: "Coût IA", Icon: LineChart, desc: "Suivi de la consommation et des dépenses IA.", testid: "adminhub-aicost" },
      { to: "/coach/canary", label: "Suivi Canary", Icon: Activity, desc: "Activation, entraînement, moteur V2, fin de cycle, business, rétention.", testid: "adminhub-canary" },
    ],
  },
  {
    title: "Système",
    hint: "Accès et administration de la plateforme.",
    items: [
      { to: "/coach/admins", label: "Admins", Icon: ShieldCheck, desc: "Gérer les comptes administrateurs.", testid: "adminhub-admins" },
    ],
  },
];

export default function CoachAdmin() {
  const navigate = useNavigate();
  return (
    <CoachLayout>
      <div className="fade-up" data-testid="admin-hub">
        <div className="flex items-center gap-2.5">
          <span className="inline-flex w-9 h-9 rounded-lg bg-sage/10 items-center justify-center"><LayoutGrid size={18} strokeWidth={1.7} className="text-sage" /></span>
          <div>
            <h1 className="text-2xl font-medium leading-tight">Administration</h1>
            <p className="text-sm text-obsidian/50">Tous les réglages de la plateforme, rangés par thème.</p>
          </div>
        </div>

        <div className="mt-8 space-y-8">
          {GROUPS.map((g) => (
            <section key={g.title} data-testid={`adminhub-group-${g.title}`}>
              <div className="mb-3">
                <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-obsidian/45">{g.title}</h2>
                <p className="text-sm text-obsidian/40">{g.hint}</p>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {g.items.map(({ to, label, Icon, desc, testid }) => (
                  <button key={to} data-testid={testid} onClick={() => navigate(to)}
                    className="group text-left rounded-xl border border-border bg-white p-4 flex items-start gap-3 transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:shadow-premium-hover hover:border-sage/40">
                    <span className="shrink-0 inline-flex w-10 h-10 rounded-lg bg-sage/10 items-center justify-center group-hover:bg-sage/15 transition-colors">
                      <Icon size={19} strokeWidth={1.7} className="text-sage" />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center justify-between gap-2">
                        <span className="font-medium text-obsidian">{label}</span>
                        <ChevronRight size={15} className="text-obsidian/25 group-hover:text-sage group-hover:translate-x-0.5 transition-[transform,color]" />
                      </span>
                      <span className="block mt-0.5 text-sm text-obsidian/55 leading-snug">{desc}</span>
                    </span>
                  </button>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </CoachLayout>
  );
}
